import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const IndustryContent = ({ data }) => {
  return (
    <>
      {/* Challenges Section */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-14">
            <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
              Challenges
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-4">
              What we solve
            </h2>
            <p className="text-lg text-slate-500 max-w-3xl leading-relaxed">
              Our expertise in {data.title.toLowerCase()} helps businesses overcome their biggest challenges
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {data.challenges.map((challenge, index) => (
              <div
                key={index}
                className="card-lift bg-white rounded-2xl p-7 border border-slate-100 group"
                style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}
              >
                <h3 className="text-xl font-bold text-slate-900 font-heading mb-3 group-hover:text-[#2693FF] transition-colors">
                  {challenge.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed">
                  {challenge.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 md:py-28" style={{ background: '#F8FAFC' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            <div>
              <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
                What We Offer
              </p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 font-heading mb-5">
                Our {data.title} services
              </h2>
              <p className="text-lg text-slate-500 leading-relaxed">
                End-to-end development services tailored to the unique needs of the {data.title.toLowerCase()} industry.
              </p>
            </div>

            <div className="space-y-3">
              {data.services.map((service, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl border border-slate-100 bg-white hover:border-slate-200 transition-all duration-200"
                  style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}
                >
                  <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#2693FF' }} />
                  <span className="text-slate-700">{service}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3 font-heading" style={{ color: '#2693FF' }}>
            Tech Stack
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 font-heading mb-10">
            Technologies we use
          </h2>
          <div className="flex flex-wrap justify-center gap-3">
            {data.technologies.map((tech, index) => (
              <span
                key={index}
                className="px-5 py-2.5 rounded-full border border-slate-200 bg-white text-slate-700 text-sm font-medium hover:border-[#2693FF] hover:text-[#2693FF] transition-colors cursor-default"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryContent;
